import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TrainingPlanningAgency } from './training-planning-agency.model';

@Injectable()
export class TrainingPlanningAgencyService {
    constructor(private http: HttpClient) {}

    findAll(): Observable<TrainingPlanningAgency[]> {
        return this.http.get<TrainingPlanningAgency[]>(
            '/api/planned-session-agencies/'
        );
    }

    findPSA(psaId): Observable<TrainingPlanningAgency> {
        return this.http.get<TrainingPlanningAgency>(
            '/api/planned-session-agencies/' + psaId
        );
    }

    edit(nextPSA: TrainingPlanningAgency) {
        return this.http.put('/api/planned-session-agencies/', nextPSA);
    }

    new(nextPSA: TrainingPlanningAgency) {
        return this.http.post('/api/planned-session-agencies/', nextPSA);
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/technical/training-planning-agency/training-planning-agency.service.ts